import {isNil} from 'ramda';

export function buildCounterLabel(
  currentLength: number,
  maxLength?: number,
  characterLabel?: string
): string {
  if (isNil(maxLength)) {
    return characterLabel ? `${currentLength} ${characterLabel}` : `${currentLength}`;
  }

  return `${currentLength} / ${maxLength}`;
}
